import { Box, styled } from '@mui/material';

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;

  margin-bottom: 20px;
`;

export default Container;
